import { ScoopText } from '../ScoopText/ScoopText'
import styles from './ScoopRadioButton.module.scss'

/**
 * ScoopRadioButton - A custom radio button component with dark mode support
 *
 * @component
 * @param {Object} props - Component props
 * @param {string} props.label - Label text for the radio button
 * @param {boolean} [props.checked=false] - Whether the radio button is checked
 * @param {boolean} [props.disabled=false] - Whether the radio button is disabled
 * @param {'sm' | 'md' | 'lg'} [props.size='md'] - Size of the radio button
 *   - sm: Small (16px radio, 14px font)
 *   - md: Medium (20px radio, 16px font) - default
 *   - lg: Large (24px radio, 18px font)
 * @param {string} [props.name] - Name attribute for the radio input
 * @param {string} [props.value] - Value attribute for the radio input
 * @param {function} [props.onChange] - Change handler function
 * @param {string} [props.className] - Additional CSS classes
 * @param {...any} props - All other props are passed to the native HTML input element
 */
export const ScoopRadioButton = ({
    label,
    checked = false,
    disabled = false,
    size = 'md',
    name,
    value,
    onChange,
    className = '',
    ...props
}) => {
    const containerClassName = [
        styles.container,
        styles[size] || styles.md,
        disabled && styles.disabled,
        className,
    ]
        .filter(Boolean)
        .join(' ')

    return (
        <label className={containerClassName}>
            <input
                type="radio"
                className={styles.input}
                checked={checked}
                disabled={disabled}
                name={name}
                value={value}
                onChange={onChange}
                {...props}
            />
            <span className={styles.radio}>
                <span className={styles.radioInner} />
            </span>
            {label && <ScoopText className={styles.label}>{label}</ScoopText>}
        </label>
    )
}

export default ScoopRadioButton
